module.exports = __webpack_public_path__ + "static/media/m7.27745c94.jpg";